import {
  SET_CONNECT_SESSION,
  SET_CHAT_CONNECTED,
  SET_CHAT_INITIAL_CONTACT_ID,
  SET_CHAT_CURRENT_CONTACT_ID,
  SET_RETRY_COUNTER,
} from "../actions/types";

const initialState = {
  connectSession: undefined,
  chatConnected: false,
  initialContactId: "",
  currentContactId: "",
  messageToSend: "",
  retryCounter: 0,
};

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {
  switch (action.type) {
    case SET_CONNECT_SESSION:
      return { ...state, connectSession: action.payload };

    case SET_CHAT_CONNECTED:
      return { ...state, chatConnected: action.payload };

    case SET_CHAT_INITIAL_CONTACT_ID:
      return {
        ...state,
        initialContactId: action.payload,
        currentContactId: action.payload,
      };

    case SET_CHAT_CURRENT_CONTACT_ID:
      return { ...state, currentContactId: action.payload };

    case SET_RETRY_COUNTER:
      return { ...state, retryCounter: action.payload };

    default:
      return state;
  }
}
